export default "__VITE_ASSET__e13d0dec__"